/**
 * Whether `file` matches an <input accept>-style list (".pdf,.zip,image/*,
 * application/dicom"). Mirrors the matching antd's <Upload> applies to
 * DROPPED files (@rc-component/upload's attr-accept) — on drop, Upload
 * silently discards anything that fails this check without ever calling
 * beforeUpload, so drop zones use this to find those files and report them.
 */
export function matchesAccept(file: File, accept: string): boolean {
  const name = file.name.toLowerCase();
  const mimeType = file.type || "";
  const baseMimeType = mimeType.replace(/\/.*$/, "");

  return accept.split(",").some((raw) => {
    const type = raw.trim().toLowerCase();
    if (!type) return false;
    if (/^\*(\/\*)?$/.test(type)) return true;
    if (type.startsWith(".")) {
      const affixes = type === ".jpg" || type === ".jpeg" ? [".jpg", ".jpeg"] : [type];
      return affixes.some((affix) => name.endsWith(affix));
    }
    if (type.endsWith("/*")) return baseMimeType === type.replace(/\/.*$/, "");
    return mimeType === type;
  });
}
